import React from 'react';
import { connect } from 'react-redux';
import { translate as t } from 'admin-on-rest';
import { getFormValues, change as onChange } from 'redux-form';
import { get } from 'lodash';
import ChipInput from 'material-ui-chip-input';

import { callApi } from '../../client/apiToolbox';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4042/api';

class TagsInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      source: this.props.source || 'tags',
    };
    this.state.url = `${API_BASE_URL}/utils/${this.props.resource}/${this.state.source}`;
  }

  componentWillMount = () => {
    this.getTags();
  }

  getTags = () => {
    callApi(this.state.url, 'GET')
      .then((data) => this.setState({ tags: data.json }));
  }

  render() {
    const { tags, source } = this.state;
    const { record, translate } = this.props;
    return (
      <ChipInput
        hintText={translate(source || 'tag')}
        dataSource={tags}
        fullWidth
        defaultValue={get(record, source)}
        onChange={(val) => this.props.change('record-form', source, val)}
      />
    );
  }
}

const selector = getFormValues('record-form');

export default connect((state) => ({ record: selector(state) }), { change: onChange })(t(TagsInput));
